module.exports = __webpack_public_path__ + "img/icon_63@2x.0e6eb655.png";